import { UserAvatar } from '@bonusly/common-user-popover';
import { Box, BoxProps } from '@bonusly/design-system';

interface UserSelectionProps extends BoxProps {
	userId?: string;
	value?: number | null;
	hideNumbers?: boolean;
	leftNumbers?: boolean;
}

export function UserSelection({ userId, value, hideNumbers = false, leftNumbers = false, ...props }: UserSelectionProps) {
	if (!userId || !value) return null;

	return (
		<Box pos="relative" h={10} w={10} {...props}>
			<Box shadow="md" rounded="full" h="full" w="full">
				<UserAvatar userId={userId} size="md" />
			</Box>
			<Box
				display={hideNumbers ? 'none' : 'block'}
				bgColor="bg.surface"
				color="text.default"
				fontSize="xs"
				fontWeight="semibold"
				px={1}
				py={0}
				pointerEvents="none"
				pos="absolute"
				rounded="sm"
				shadow="sm"
				right={leftNumbers ? 'auto' : '-10px'}
				left={leftNumbers ? '-10px' : 'auto'}
				top="-10px"
			>
				{value.toFixed(1)}
			</Box>
		</Box>
	);
}
